module.exports = __webpack_public_path__ + "assets/img/4.e70d9c27.png";